import {connect} from '@modifi/redux'
import {getAuthenticatedAdminThemisClient} from '@modifi/onboarding-api-clients'
import {selectPathname} from '@modifi/router'
import {OnboardingActivationStatus} from '@modifi/enums'

import SearchFilter, {SearchFilterProps} from './SearchFilter'
import {ROUTE_TASKS} from '../../routes/constants'

const apiClient = getAuthenticatedAdminThemisClient()

const mapStateToProps = (
  state: Record<string, any>
): Pick<SearchFilterProps, 'search' | 'filterKey'> => ({
  search: (searchString: string): Promise<any[]> =>
    apiClient.Company.fetch({
      'search.companyName': searchString,
      pageIndex: 0,
      pageSize: 5,
      orderBy: ['companyName'],
      orderDirection: ['ASC'],
      resultFields: ['companies.externalId', 'companies.companyName'],
      'filter.activation.activationStatus': [
        OnboardingActivationStatus.ACTIVATED,
        OnboardingActivationStatus.APPROVED,
        OnboardingActivationStatus.COMPLETED,
        OnboardingActivationStatus.DEACTIVATED,
        OnboardingActivationStatus.DENIED,
        OnboardingActivationStatus.INCOMPLETE,
        'UNDERWRITING',
        'LIMIT_CHECK',
      ],
    })
      .then(response => response.data().companies)
      .then((companies = []) =>
        companies.map(({externalId: value, companyName}) => ({label: companyName, value}))
      ),
  filterKey:
    selectPathname(state) === ROUTE_TASKS ? 'filter.externalCompanyId' : 'filter.externalId',
})

export default connect(mapStateToProps)(SearchFilter)
